export type ItemTypes = Record<string, string>;

export const itemTypes: ItemTypes = {
  NOTE_LIST_ITEM: 'note_list_item'
};
